const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCoachSession = () => {
  let s = localStorage.getItem("nrc_coach_session");
  if (!s) {
    s = crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("nrc_coach_session", s);
  }
  return s;
};

export const fetchCoachHistory = async (sessionId) => {
  const res = await fetch(`${API}/coach/history/${sessionId}`);
  if (!res.ok) return [];
  const data = await res.json();
  return data.messages || [];
};

export const streamCoach = async (sessionId, message, onDelta) => {
  const res = await fetch(`${API}/coach/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Coach is unavailable right now.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (payload === "[DONE]") return;
      let obj;
      try {
        obj = JSON.parse(payload);
      } catch {
        continue;
      }
      if (obj.error) throw new Error(obj.error);
      if (obj.delta) onDelta(obj.delta);
    }
  }
};
